import { useCallback, useMemo } from 'react';

import { chatCommunicationController } from '../../controllers/chatCommunication/ChatCommunicationControllerConnector';
import { generateMessage } from '../../utils/chat';
import { fetchLiveSupportMessagesAction } from '../apiActions/fetchLiveSupportMessagesAction';
import { useCoreDispatch } from '../CoreStore';
import { useChatSlice } from '../slices/chat/selectors';
import type { Message } from '../slices/chat/types';
import { useConfigSlice } from '../slices/config/selectors';

export const useLiveSupportMessagesFetcher = (essential: boolean): (() => void) => {
  const chatUrl = useConfigSlice.env()?.chat;
  const tableId = useConfigSlice.tableId() ?? '';
  const userId = useConfigSlice.userId() ?? '';
  const casinoId = useConfigSlice.session()?.casinoId ?? '';

  const chatSubscriptionState = useChatSlice.getChatSubscriptionState();
  const isChatSubscribed = chatSubscriptionState === 'SUBSCRIBED';

  const dispatch = useCoreDispatch();

  const freshChatSubscriptionMessage: Message = useMemo(() => {
    return {
      ...generateMessage(userId, '', tableId, casinoId),
      isliveSupportChat: true,
    };
  }, [casinoId, tableId, userId]);

  return useCallback(() => {
    if (chatUrl && tableId && userId && isChatSubscribed) {
      chatCommunicationController.sendMessage(JSON.stringify(freshChatSubscriptionMessage)); // Initiate Freshchat conversation with support agent

      dispatch(
        fetchLiveSupportMessagesAction({
          url: `${chatUrl}/api/fetchMessages`,
          offset: 0,
          recordsPerPage: 100,
          tableId: tableId,
          tagMessage: 'SUPPORT',
          timestamp: Date.now(),
          userId: userId,
          action: 'COMMAND',
          essential,
        })
      );
    }
  }, [chatUrl, dispatch, essential, freshChatSubscriptionMessage, isChatSubscribed, tableId, userId]);
};
